import { lesson, requestState } from "../actions/index";

export default (initialState, action) => {
	switch (action.type) {
		case requestState.LOADING:
			return {
				...initialState,
				loading: true,
			};

		case lesson.GET_LESSONS:
			return {
				...initialState,
				lessons: action.payload,
				loading: false,
			};
		case lesson.GET_NEXT_LESSONS:
			initialState.lessons.docs = initialState.lessons.docs.concat(action.payload.docs);
			//console.log(action.payload.docs);
			initialState.lessons.totalDocs = action.payload.totalDocs;
			initialState.lessons.limit = action.payload.limit;
			initialState.lessons.totalPages = action.payload.totalPages;
			initialState.lessons.page = action.payload.page;
			initialState.lessons.pagingCounter = action.payload.pagingCounter;
			initialState.lessons.hasPrevPage = action.payload.hasPrevPage;
			initialState.lessons.hasNextPage = action.payload.hasNextPage;
			initialState.lessons.prevPage = action.payload.prevPage;
			initialState.lessons.nextPage = action.payload.nextPage;
			//console.log('execution du reducer');
			return {
				...initialState,
				loading: false,
			};

		case lesson.GET_NEXT_PRONUNCIATIONS:
			initialState.pronunciations.docs = initialState.pronunciations.docs.concat(action.payload.docs);
			//console.log(action.payload.docs);
			initialState.pronunciations.totalDocs = action.payload.totalDocs;
			initialState.pronunciations.limit = action.payload.limit;
			initialState.pronunciations.totalPages = action.payload.totalPages;
			initialState.pronunciations.page = action.payload.page;
			initialState.pronunciations.pagingCounter = action.payload.pagingCounter;
			initialState.pronunciations.hasPrevPage = action.payload.hasPrevPage;
			initialState.pronunciations.hasNextPage = action.payload.hasNextPage;
			initialState.pronunciations.prevPage = action.payload.prevPage;
			initialState.pronunciations.nextPage = action.payload.nextPage;
			//console.log('execution du reducer');
			return {
				...initialState,
				loading: false,
			};

		case lesson.GET_NEXT_TIPS:
			initialState.tips.docs = initialState.tips.docs.concat(action.payload.docs);
			//console.log(action.payload.docs);
			initialState.tips.totalDocs = action.payload.totalDocs;
			initialState.tips.limit = action.payload.limit;
			initialState.tips.totalPages = action.payload.totalPages;
			initialState.tips.page = action.payload.page;
			initialState.tips.pagingCounter = action.payload.pagingCounter;
			initialState.tips.hasPrevPage = action.payload.hasPrevPage;
			initialState.tips.hasNextPage = action.payload.hasNextPage;
			initialState.tips.prevPage = action.payload.prevPage;
			initialState.tips.nextPage = action.payload.nextPage;
			//console.log('execution du reducer');
			return {
				...initialState,
				loading: false,
			};

		case lesson.COUNT_LESSONS:
			return {
				...initialState,
				lessonTotal:
					action.payload.length > 0 && action.payload.find((item) => item._id === "lesson")
						? action.payload.find((item) => item._id === "lesson").count
						: 0,
				pronunciationTotal:
					action.payload.length > 0 && action.payload.find((item) => item._id === "Pronunciation")
						? action.payload.find((item) => item._id === "Pronunciation").count
						: 0,
				tipsTotal:
					action.payload.length > 0 && action.payload.find((item) => item._id === "Tips&Tricks")
						? action.payload.find((item) => item._id === "Tips&Tricks").count
						: 0,
				loading: false,
			};

		case lesson.GET_PRONUNCIATION:
			return {
				...initialState,
				pronunciations: action.payload,
				loading: false,
			};

		case lesson.GET_TIPS:
			return {
				...initialState,
				tips: action.payload,
				loading: false,
			};

		case lesson.GET_LESSON:
			return {
				...initialState,
				lesson: action.payload.lesson,
				nextLesson: action.payload.nextLesson,
				loading: false,
			};

		case lesson.FILTER_LESSON:
			return {
				...initialState,
				lessonFilter: initialState.lessons.docs.filter((item) => {
					const regex = new RegExp(`${action.payload}`, "gi");
					if (item.title.match(regex)) {
						return item;
					} else {
						return null;
					}
				}),
				loading: false,
			};
		case lesson.FILTER_PRONUNCIATION:
			return {
				...initialState,
				pronunciationFilter: initialState.pronunciations.docs.filter((item) => {
					const regex = new RegExp(`${action.payload}`, "gi");
					if (item.title.match(regex)) {
						return item;
					} else {
						return null;
					}
				}),
				loading: false,
			};
		case lesson.FILTER_TIPS:
			return {
				...initialState,
				tipFilter: initialState.tips.docs.filter((item) => {
					const regex = new RegExp(`${action.payload}`, "gi");
					if (item.title.match(regex)) {
						return item;
					} else {
						return null;
					}
				}),
				loading: false,
			};

		case requestState.ERROR:
			return {
				...initialState,
				loading: false,
				error: action.payload,
			};
		case lesson.CLEAR_CURRENT_LESSON:
			return {
				...initialState,
				lesson: null,
				loading: false,
			};

		case requestState.CLEAR_NOTIFICATION:
			return {
				...initialState,
				error: null,
				success: null,
			};
		default:
			return { ...initialState, loading: false };
	}
};
